import logoUrl from '@/assets/LogoForni.png';
import iconUrl from '@/assets/fornitalia-icon.jpg';
import { cn } from '@/shared/lib/cn';

/**
 * Brand lockup. `LogoForni.png` is the full wordmark+icon brand image used
 * everywhere the brand appears at normal size (sidebar, login, splash).
 * `fornitalia-icon.jpg` is the standalone icon, kept for tight spots that
 * need only the mark (favicon, dense nav items).
 */
type Variant = 'horizontal' | 'icon' | 'stacked';

export function FornitaliaLogo({
  variant = 'horizontal',
  size = 'md',
  className,
}: {
  variant?: Variant;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  if (variant === 'icon') {
    const iconSize = size === 'sm' ? 'h-8 w-8' : size === 'lg' ? 'h-16 w-16' : 'h-12 w-12';
    return (
      <span className={cn('inline-flex items-center', className)}>
        <img
          src={iconUrl}
          alt=""
          className={cn('shrink-0 rounded-md object-contain', iconSize)}
          draggable={false}
        />
      </span>
    );
  }

  const logoHeight = size === 'sm' ? 'h-14' : size === 'lg' ? 'h-24' : 'h-16';

  return (
    <div
      className={cn(
        variant === 'stacked' ? 'flex flex-col items-center' : 'flex items-center',
        className,
      )}
    >
      <img
        src={logoUrl}
        alt="Fornitalia"
        className={cn('w-auto object-contain', logoHeight)}
        draggable={false}
      />
    </div>
  );
}
